import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { Testimonial } from '~/types/models/testimonial';
import IntroPage from '~/App/Modules/Testimonials/Components/Common/IntroPage';
import TestimonialContext, { defaultTestimonialStyles } from '~/App/Modules/Testimonials/Context/TestimonialContext';
import { FeaturesContext } from '~/react-hooks/use-features';
import ResponsesRoute, {
  landingPageBaseRoute,
} from './TestimonialLandingPage/ResponsesRoute';

import useLanguage from '../i18n';
import WebFont from 'webfontloader';

declare global {
  const testimonialResource: Testimonial;
}

export default function TestimonialLandingPage() {
  // Taken from the value from blade
  // see: window.testimonialResource
  const testimonial = {
    ...testimonialResource,
    metadata: {
      ...testimonialResource?.metadata,
      style: {
        ...defaultTestimonialStyles,
        ...testimonialResource?.metadata?.style,
      }
    }
  } as Testimonial;

  const features = window.config.features;

  useLanguage(testimonial.user.lang);

  const fontFamily = testimonial?.metadata?.style?.font_family;
  
  useEffect(() => {
    if (!fontFamily) return;

    WebFont.load({
      google: {
        families: [fontFamily],
      },
    });
  }, [fontFamily]);

  return (
    <FeaturesContext.Provider value={features}>
      <TestimonialContext.Provider value={testimonial}>
        <BrowserRouter>
          <Switch>
            <Route
              path={`${landingPageBaseRoute}/:respondent_id`}
              component={ResponsesRoute}
            />
            <Route path={landingPageBaseRoute} component={IntroPage} />
          </Switch>
        </BrowserRouter>
      </TestimonialContext.Provider>
    </FeaturesContext.Provider>
  );
}
